export interface IReceiptTemplate {
  size: 'A1' | 'A2' | 'A3' | 'A4';
  data: IReceiptSections[];
}

export interface IReceiptSections {
  section:
    | IReceiptHeaderSection
    | IReceiptDataSection
    | IReceiptFooterSection
    | IReceiptHotlineDataSection;
}

export interface IReceiptHeaderSection {
  logoURL: string;
  title: string;
  subTitle: string;
  receiptName: string;
  backgroundColor: string;
  fontColor: string;
}

export interface IReceiptFooterSection {
  footerNote: string;
  backgroundColor: string;
  fontColor: string;
  position?: 'FIXED' | 'RELATIVE';
  breakPage?: boolean;
}

export interface IReceiptDataSection {
  dataSectionType:
    | 'TITLE_BAR'
    | 'SPACE_BAR'
    | 'MULTI_DATA'
    | 'HORIZONTAL_RULER'
    | 'PAYABLE_BAR'
    | 'TOTAL_BAR';
  data?:
    | ITitleBarDataElement[]
    | ISpaceDataElement[]
    | IMultiDataElement[]
    | IContentBarDataElements[]
    | IHorizontalRulerElement;
}

export interface ITitleBarDataElement {
  value: string;
  options?: IOptions;
}

export interface IHorizontalRulerElement {
  options?: IHorizontalRulerOptions;
}

export interface IHorizontalRulerOptions extends IOptions {
  width?: string;
}

export interface ISpaceDataElement {
  height?: string;
}

export interface ITextDataElement {
  textValue: string;
  options?: IOptions;
}

export interface IKeyValuePairDataElement {
  key: string;
  value: string;
  subtext?: string;
  isSubtextIndented?: boolean;
  options?: IOptions;
}

export interface IMultiDataElement {
  data: IMultiDataOptions[];
}

export interface IReceiptHotlineDataSection {
  qrDataURL: string;
  infoTexts: string[];
  hotlineNumber: string;
  qrHelpMessage?: string;
}

export interface IMultiDataOptions {
  elementType: ELEMENT_TYPE;
  value:
    | ITwoColumnTableData
    | ITwoColumnPageSectionData
    | ITextDataElement[]
    | IKeyValuePairDataElement[]
    | IMultiColumnTableData[];
  config?: IMultiColumnTableDataConfig; // TODO: add other config as well
}

export interface IContentBarDataElements {
  value: IKeyValuePairDataElement[];
  options?: IOptions;
}

// TODO: add font face
export interface IOptions {
  fontSize?: string;
  fontColor?: string;
  fontWeight?: string;
  fontFace?: string;
  margin?: string;
  padding?: string;
  lineHeight?: string;
  marginBottom?: string;
  marginTop?: string;
  backgroundColor?: string;
  align?: 'center' | 'left' | 'right' | 'justify';
}

export interface ITwoColumnTableData {
  header: string;
  values: IKeyValuePairDataElement[];
  footer?: IKeyValuePairDataElement;
}

export interface ITwoColumnPageSectionData {
  values: IKeyValuePairDataElement[];
}

export interface IMultiColumnTableData {
  columnValues: string[];
  options?: IOptions;
}

export interface IMultiColumnTableDataConfig {
  enableLastColumn?: boolean;
}

export enum SECTION_TYPE {
  HEADER_SECTION = 'HEADER_SECTION',
  DATA_SECTION = 'DATA_SECTION',
  FOOTER_SECTION = 'FOOTER_SECTION',
}

export enum ELEMENT_TYPE {
  TEXT = 'TEXT',
  KEY_VALUE_PAIR_TABLE = 'KEY_VALUE_PAIR_TABLE',
  KEY_VALUE_SPLIT_PAIR_TABLE = 'KEY_VALUE_SPLIT_PAIR_TABLE',
  TWO_COLUMN_TABLE = 'TWO_COLUMN_TABLE',
  MULTI_COLUMN_TABLE = 'MULTI_COLUMN_TABLE',
  TWO_PAGE_SECTION = 'TWO_PAGE_SECTION',
  END_DOCUMENT = 'END_DOCUMENT',
  TWO_PAGE_WITH_BACKGROUND = 'TWO_PAGE_WITH_BACKGROUND',
}
